import React, { useMemo } from 'react';



import './Day.css'
import { day, month } from '../../other/Date';



const Day: React.FC = () => {


   // Кейс місяців
   const monthName = useMemo(() => {
      switch (month) {
         case '01':
            return <span>January</span>;
         case '02':
            return <span>February</span>;
         case '03':
            return <span>March</span>;
         case '04':
            return <span>April</span>;
         case '05':
            return <span>May</span>;
         case '06':
            return <span>June</span>;
         case '07':
            return <span>July</span>;
         case '08':
            return <span>August</span>;
         case '09':
            return <span>September</span>;
         case '10':
            return <span>October</span>;
         case '11':
            return <span>November</span>;
         case '12':
            return <span>December</span>;
         default:
            return day;
      }
   }, [month]);


   return (
      <div className='main_day'>
         <img src="./img/header/logo.png" alt="" />
         <h1 className='main_day_title'>{monthName} {day} </h1>
         <div className='under_main_day_description'>Welcome to ITIS. Hope you don't get bored.</div>
      </div>
   )
}

export default Day;